var userTitle = function (text) {
    if (text === void 0) { text = 'Авторизация'; }
    var title = document.createElement('h3');
    title.className = 'user-header';
    title.textContent = "".concat(text, " \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F");
    return title;
};
var errorLogin = 'Не правильное имя пользователя и/или пароль';
var errorSignin = 'Пользователь с указанным email уже существует';
var errorMessage = function (type) {
    var text = type ? errorSignin : errorLogin;
    return "<div id=\"user-error-msg-holder\" class=\"show\">\n  <p id=\"user-error-msg\">".concat(text, "</p>\n  </div>");
};
var isShowElement = function (element) {
    if (!element.classList.contains('open')) {
        element.classList.add('open');
    }
};
var isHideElement = function (element) {
    if (element.classList.contains('open')) {
        element.classList.remove('open');
    }
};
var isToggleElement = function (tag) {
    var element = document.querySelector(tag);
    if (element.classList.contains('open')) {
        element.classList.remove('open');
    }
    else {
        element.classList.add('open');
    }
};
var removeElement = function (tag) {
    setTimeout(function () {
        var element = document.querySelector(tag);
        element.remove();
    }, 3000);
};
var getSpinner = {
    tag: '.loading',
    elementSpinner: '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>',
    add: function () {
        var loading = document.createElement('div');
        var container = document.createElement('div');
        var overflow = document.createElement('div');
        overflow.className = 'loading__overflow';
        container.className = 'loading__spinner';
        loading.className = 'loading';
        container.insertAdjacentHTML('afterbegin', getSpinner.elementSpinner);
        loading.append(overflow, container);
        return loading;
    },
    show: function (parent) {
        var spinner = parent.querySelector(getSpinner.tag);
        if (!spinner.classList.contains('active'))
            spinner.classList.add('active');
    },
    hide: function (parent) {
        var spinner = parent.querySelector(getSpinner.tag);
        if (spinner.classList.contains('active'))
            spinner.classList.remove('active');
    },
};
export { userTitle, errorMessage, isToggleElement, removeElement, isShowElement, isHideElement, getSpinner, };
